import Seo from "@/components/Seo";
import { PageHero, BadgeAC, NDA_LABEL } from "@/components/Shared";

const Section = ({ titre, children }) => (
  <div className="mb-12">
    <h2 className="font-serif text-2xl text-marine mb-4">{titre}</h2>
    <div className="font-sans text-[15px] text-marine/80 leading-[1.8] space-y-3">{children}</div>
  </div>
);

export default function MentionsLegales() {
  return (
    <div data-testid="page-mentions-legales">
      <Seo
        title="Mentions légales — Form Action Pro"
        description="Mentions légales du site formactionpro.net : éditeur, déclaration d'activité n°93830854183, directeur de la publication, hébergeur, propriété intellectuelle."
        path="/mentions-legales"
      />
      <PageHero kicker="Informations légales" title="Mentions légales" />

      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Section titre="Éditeur du site">
            <p>
              <strong>Form Action Pro</strong> — François Schoonheere, entrepreneur individuel
              <br />
              SIREN : 538 757 709
              <br />
              Siège : Résidence Les Émeraudes, 83420 La Croix Valmer, France
              <br />
              E-mail :{" "}
              <a href="mailto:form.action1pro@gmail.com" className="text-vert-dark hover:underline">
                form.action1pro@gmail.com
              </a>
              <br />
              Téléphone : 07 69 05 76 73
            </p>
          </Section>

          <Section titre="Déclaration d’activité de formation">
            <p data-testid="ml-nda">{NDA_LABEL}</p>
          </Section>

          <Section titre="Directeur de la publication">
            <p>François Schoonheere.</p>
          </Section>

          <Section titre="Hébergement">
            <p>
              Hébergeur du site : Emergent <BadgeAC label="Coordonnées hébergeur à préciser" />
            </p>
          </Section>

          <Section titre="Médiateur de la consommation">
            <p>
              En cas de litige relatif à une prestation, et après tentative de résolution amiable
              auprès de Form Action Pro, vous pouvez saisir le médiateur de la consommation
              compétent : <BadgeAC label="À COMPLÉTER" />
            </p>
          </Section>

          <Section titre="Propriété intellectuelle">
            <p>
              L’ensemble des contenus du site (textes, visuels, structure, marques) est protégé par
              le droit de la propriété intellectuelle. Toute reproduction, représentation ou
              exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.
            </p>
            <p>
              « Le Monde en fiches », « L’IA sans jargon », « Atlas économique mondial » et « Le
              petit dico de l’IA » sont des publications de François Schoonheere.
            </p>
          </Section>

          <Section titre="Liens externes">
            <p>
              Le site contient des liens vers des sites tiers (plateformes de vente des ouvrages,
              tablecho.com). Form Action Pro n’est pas responsable de leurs contenus ni de leurs
              pratiques.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
}
